<h3 id="fundraising">{{metadata.attributes.HEADING}}</h3>
<p>{{metadata.attributes.DESCRIPTION}}</p>
<div *ngIf="(storeService.vm$ | async) as vm">
  <div *ngIf="!vm.under18">
    <input
      id="populateSchoolInformation"
      type="checkbox"
      name="populateSchoolInformation"
      [ngModel]="vm.populateSchoolInformation"
      (ngModelChange)="storeService.updateState({ populateSchoolInformation: $event })"
      #populateSchoolInformation="ngModel">
    <label for="populateSchoolInformation" class="d-inline">
      Provide School Information?
    </label>
  </div>
  <form #form="ngForm" >
    <div class="form-row" *ngIf="vm.under18 || vm.populateSchoolInformation">
      <div class="form-group col-md-6" id="school-questions-schoolName">
        <label for="schoolName">High School Name</label>
        <input
          type="text"
          class="form-control"
          id="schoolName"
          name="schoolName"
          maxlength="50"
          [(ngModel)]="schoolQuestions.schoolName"
          [required]="vm.under18 || vm.populateSchoolInformation"
          #schoolName="ngModel">
        <control-errors [control]="schoolName" name="High School Name"></control-errors>
      </div>
      <div class="form-group col-md-6" id="school-questions-schoolEndYear">
        <label for="schoolEndYear">What year do you expect to graduate high school?</label>
        <select
          class="form-control form-select"
          name="schoolEndYear"
          id="schoolEndYear"
          [(ngModel)]="schoolQuestions.schoolEndYear"
          [required]="!!vm.under18"
          #schoolEndYear="ngModel"
        >
          <option class="form-control form-select" *ngFor="let year of years" [ngValue]="year.id">{{year.description}}</option>
        </select>
        <div *ngIf="schoolEndYear.touched && schoolEndYear.invalid" class="invalid-feedback">
          Please provide a year
        </div>
      </div>
    </div>
  </form>
</div>
